import Ref from "./Ref";
import Definition from './Definition';
export default class RefPointer extends Ref {

    get value() {
        if(!this.isLoaded) throw new Error('Accessing an unloaded RefPointer');
        return this.instance;
    }

    get isLoaded() {
        return !!this.instance;
    }

    /**
     * Check if this pointer is a pointer to a Remittance
     * 
     * @remarks If so, `instanceKey` will be formatted as `employerId_period`
     * @returns {boolean} True if the pointer has name `remittance` and registry `remittances`
     */
    get isRemittancePointer() {
        return this.registryKey === 'remittances' && this.name === 'remittance';
    }

    /**
     * Check if this pointer is a pointer to an Employment
     * 
     * @remarks If so, `instanceKey` will be formatted as `employerId`
     * @returns {boolean} True if the pointer has name `employer` and registry `employers`
     */
    get isEmploymentPointer() {
        return this.registryKey === 'employers' && this.name === 'employer';
    }

    /**
     * Whitelist of the RefPointer {@link definitions} properties to include in the payload
     * @returns {['registryKey', 'name', 'instanceKey']}
     */
    getPayloadInclusions() { return ['registryKey', 'name', 'instanceKey']};

    async load() {
        if(!this.isLoaded) {
            const registry = require('../../../services/ServiceRegistry').default;
            this.instance = await registry.loadPointer(this);
        }
        return this;
    }

    static definitions = {
        // persistent
        registryKey: { type: Definition.types.STRING, text: 'Registry Key' },
        name: { type: Definition.types.STRING, text: 'Name' },
        instanceKey: { type: Definition.types.STRING, text: 'Key Value' },
        // transient
        instance: { transient: true, type: Definition.types.ENTITY, text: 'Instance' },
        // computed
        isLoaded: { abstract: true, type: Definition.types.BOOLEAN, text: 'Is Loaded' },
        value: { abstract: true, text: 'Entity' },
    }
}